module.exports = __webpack_public_path__ + "img/blender.a6949161.png";